import React from 'react'
import Container from '../Container/Index'
import Title from '../Title/Index'
import ImageTag from '../ImageTag/Index'

const Moto = ({Data, certificate}) => {
  return (
   <>
    <Container _parentClass={'ourMoto'} containerClass={'float-end '}>
      <div className='col-lg-9 col-12 m-auto'>
      {(Data.title || Data.heading) && (
  <Title firstHeading={Data.title} secondHeading={Data.heading} />
)}
     <div className='row align-items-center'>
     <div className='col-lg-6 col-12 mb-3 mb-lg-0' data-aos="fade-right"
          data-aos-offset="100"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-easing="ease-in-sine">
            <ImageTag ImagePath={Data.imagePath} ImageAlt='Our Quality Arsus Global' ImageWidth={650} ImageHeight={450}/>
          </div>
          <div className="col-lg-6 col-12" data-aos="fade-left"
          data-aos-offset="100"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-easing="ease-in-sine">
            <p dangerouslySetInnerHTML={{ __html: Data.content1}}/>
            <p dangerouslySetInnerHTML={{ __html: Data.content2}}/>
               <ul className='motoListitems'>
            {Data.points.map((items, index) => (
          <li key={index}>{items}</li>
        ))}
      </ul>          
         
        </div>   
     </div>
     </div>        
    </Container>
    {certificate?.certificateLogo?.length > 0 && (
        <Container containerClass="float-end">
          <Title 
            firstHeading={certificate.title} 
            secondHeading={certificate.heading}
            subTitle={certificate.description}

          />
          <div className="col-12 float-start d-flex justify-content-center text-center">
            <ul className="d-flex justify-content-center align-items-center gap-3 list-unstyled flex-wrap">
              {certificate.certificateLogo.map((logo, index) => (
                <li 
                  key={index} 
                  className="border py-lg-1 px-lg-3 bg-white rounded"
                  data-aos="fade-up"
                  data-aos-offset="100"
                  data-aos-duration="1000"
                  data-aos-once="true"
                  data-aos-easing="ease-in-sine"
                >
                  <ImageTag 
                    ImagePath={logo.imagePath} 
                    ImageAlt={logo.imageAlt}
                    className="img-fluid"
                    ImageWidth={300}
                    ImageHeight={200}
                  />
                </li>
              ))}
            </ul>
          </div>
        </Container>
      )}
   </>
  )
}

export default Moto